/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pretty_Yummy_Ape_QuizInputs */

const fr_pretty_yummy_ape_quiz = /** @type {(inputs: Pretty_Yummy_Ape_QuizInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un programme`)
};

/**

* @param {Pretty_Yummy_Ape_QuizInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pretty_yummy_ape_quiz = /** @type {((inputs?: Pretty_Yummy_Ape_QuizInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pretty_Yummy_Ape_QuizInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pretty_yummy_ape_quiz(inputs)
});